import assign from 'lodash/assign';
import * as APIS from '../../constants/api';

export const orderManagement =
  (action, payload) =>
  (dispatch, getState, { api }) =>
    api
      .post(APIS.ORDER_MANAGEMENT, assign({ action }, payload))
      .then((result) => {
        return result;
      })
      .catch((error) => {
        throw error;
      });

export const z = 14;
